import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Design } from 'src/app/models/domain';
import { DesignAdapter } from 'src/app/models/domain/adapters';
import { DesignSetService, YPMDESIGNSRVDesign } from 'src/generated-clients/design';

@Injectable({
  providedIn: 'root',
})
export class DesignDataService {
  private readonly responsibleUserPropertyName: keyof YPMDESIGNSRVDesign = 'responsibleUser';

  public constructor(
    private readonly designService: DesignSetService,
    private readonly designAdapter: DesignAdapter
  ) {}

  public getByResponsibleUser(userName: string): Observable<Design[]> {
    const filter = `${this.responsibleUserPropertyName} eq '${userName.toUpperCase()}'`;

    return this.designService
      .designSetGet(undefined, undefined, filter, undefined, ['createdOn desc'])
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          if (!res.d?.results) {
            throw new Error('SAP Error');
          }

          return res.d.results.map((design) => this.designAdapter.adaptToDomain(design));
        })
      );
  }

  public getByDesignId(designId: string): Observable<Design> {
    return this.designService.designSetDesignIdGet(designId).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d) {
          const errorMsg = `Could not find design with id: ${designId}`;

          throw new Error(errorMsg);
        }

        return this.designAdapter.adaptToDomain(res.d);
      })
    );
  }
}
